import { useDropzone } from "react-dropzone";
import { useTranslation } from "react-i18next";
import { UploadCloud as UploadFile } from "lucide-react";
import { Download as Downloading } from "lucide-react";

export function DropZoneComponent({
  label,
  doDrop,
  disable,
  hidden,
  isUploading,
  multiple,
}: {
  hidden?: boolean;
  label?: string;
  disable?: boolean;
  doDrop: (files: any) => void;
  isUploading?: boolean;
  multiple?: boolean;
}) {
  const onDrop = (acceptedFiles: any) => {
    doDrop(acceptedFiles);
  };

  const { getRootProps, getInputProps } = useDropzone({
    onDrop,
    disabled: disable,
    multiple: multiple ?? false,
  });

  const { t } = useTranslation();

  return (
    <div
      hidden={hidden}
      {...getRootProps({
        className: `dropzone cursor-pointer w-full ${
          disable ? "cursor-not-allowed" : ""
        }`,
      })}
    >
      <section className="container bg-white border-dashed border p-2 text-center flex items-center justify-center rounded-md border-primary/80 w-full font-normal">
        <input {...getInputProps()} />
        <div className="flex gap-2 items-center">
          {disable ? (
            <Downloading className="text-gray-500 text-sm rotate-180 h-4 w-4" />
          ) : (
            <UploadFile className="text-gray-500 text-sm h-4 w-4" />
          )}
          {isUploading ? (
            <span className="text-gray-500 text-sm py-8">
              {t("Uploading")}...
            </span>
          ) : (
            <span className="text-gray-500 text-sm py-8">
              {label ?? t("Upload document")}
            </span>
          )}
        </div>
      </section>
    </div>
  );
}

export default DropZoneComponent;
